module.exports = __webpack_public_path__ + "img/LOGO_EURECA_LONGUEUR_DEGRADE_NOIR.fa4fa8c1.png";